export const SET_BUCKET_DOMAIN = "SET_BUCKET_DOMAIN";
export const SET_BUCKET_DOMAIN_TOKEN = "SET_BUCKET_DOMAIN_TOKEN";
export const SET_MENU_ACTIVE_INDEX = "SET_MENU_ACTIVE_INDEX";
